module.exports = __webpack_public_path__ + "static/media/rss.2201da43.svg";